export default {
    classes: {},
    data: [],
    config: {
        columns: [],
        actions: []
    },
    onRowSelect: () => {},
    noAvatar: false,
    disableSelect: false,
    rowsInView: 10,
    avatar: {
        nameKey: 'first_name',
        urlKey: 'avatar_url',
        colorKey: 'avatar_color'
    },
    noDataMessage: 'No Data Found'
}